import { ICountryOrState, IAddress, IValidation, IUserAddressRulesField } from 'base/interfaces/address';
import { isOnlyStateHandleCountries } from '@base/account/address/const'

// 必填的正则
const RequiredRegArr = [
    '^(?!\\s*$).+',
]

// 通过name 获取对应数据
export const getTargetCountryInfoWithName = (
    name: string,
    listMap: Record<string | number, ICountryOrState>
): ICountryOrState | undefined => {
    if (!listMap) {
        return void 0
    }
    const keys: string[] = Object.keys(listMap)

    let _target
    for (let i = 0; i < keys.length; i++) {
        if ((listMap?.[keys?.[i]].name || '').toLowerCase() === name?.toLowerCase()) {
            _target = listMap[keys[i]]
            break
        }
    }
    return _target
}

export const getOptions = (list: ICountryOrState[]) => {
    // select 搜索 是匹配value
    return list?.map(item => {
        return {
            label: item.name,
            value: item.name,
            id: item.id
        }
    }) || []
};


/** addresses 可选排序
 * @param addressList -- 地址列表
 * @param webSelectedCountryId  -- 网站选中的国家id
 * @param selectedAddress  --已选中的地址
 */
export const sortDisabledAddressList = (
    addressList: IAddress[],
    webSelectedCountryId: number,
    selectedAddress?: IAddress
): IAddress[] => {
    // 排序disable
    const disableAddressList = addressList
        .filter(item => item.countryId !== webSelectedCountryId)
        .map((item) => {
            return {
                ...item,
                isDisabled: true,
                isSelectedOn: item.id == selectedAddress?.id
            }
        })
    const ableAddressList = addressList
        .filter(item => item.countryId == webSelectedCountryId)
        .map((item) => {
            return {
                ...item,
                isDisabled: false,
                isSelectedOn: item.id == selectedAddress?.id
            }
        })

    return [...ableAddressList, ...disableAddressList]
};


// 判断是否在当前国家里
export const checkInCurrentCountry = (
    value: any,
    currentCountryObj: ICountryOrState | undefined
) => {
    return !value ||
        (currentCountryObj?.children as ICountryOrState[])?.find((pItem: any) => pItem.name === value)
}

// 判断是否在当前省份里
export const checkInCurrentProvince = (
    value: string,
    isOnlyState: boolean,
    cityList: any[]
) => {
    return !value ||
        isOnlyState ||
        !cityList.length ||
        cityList?.find((item: any) => item.name.toLowerCase() === value.toLowerCase())
};


// 表单认证错误 focus FormItem
export const focusErrInfoFormItem = (errorInfo) => {
    const errorId = errorInfo?.errorFields?.[0]?.name?.[0]
    if (errorId) {
        const targetEl = document?.getElementById(errorId)
        if (targetEl) {
            targetEl.focus()
            // input 可能id之下子元素
            targetEl.getElementsByTagName('input')?.[0]?.focus()
        }
    }
}


export const getFormItemRules = (params: IUserAddressRulesField) => {
    const { validation, optional = true, labelTitle } = params;

    let _rules: any[] = [];
    let isRequired = !optional;
    let isRepeatRegRequired = false

    for (let i = 0; i < validation.length; i++) {
        let vItem = validation[i];
        const isRegRequired = RequiredRegArr.includes(vItem.checkRegex);

        if (isRegRequired) {
            isRepeatRegRequired = true
            _rules.push({
                required: true,
                message: vItem?.error || ''
            });
        }

        _rules.push({
            pattern: new RegExp(`${vItem.checkRegex}`),
            message: vItem.error,
        })

    }

    if (isRequired && !isRepeatRegRequired) {
        _rules.push({
            required: true,
        })
    }

    return _rules || [];
}


export const checkInputType = (rules: IUserAddressRulesField) => {
    return rules?.inputType === 'text'
}

export const checkCityInputType = (config: {
    countryCode: string;
    rules?: IUserAddressRulesField;
}) => {
    const {
        countryCode, rules
    } = config

    const isOnlyState = isOnlyStateHandleCountries.includes(countryCode || '')

    return (!rules ? false : checkInputType(rules)) || isOnlyState
}